
import React from 'react';
import { cn } from '@/lib/utils';

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  as?: React.ElementType;
  size?: 'default' | 'small' | 'medium' | 'large' | 'full';
}

const Container = ({
  children,
  as: Component = 'div',
  className,
  size = 'full', 
  ...props
}: ContainerProps) => {
  const sizeClasses = {
    small: 'max-w-3xl mx-auto px-0 md:px-6 lg:px-8',
    medium: 'max-w-5xl mx-auto px-0 md:px-6 lg:px-8',
    default: 'max-w-7xl mx-auto px-0 md:px-6 lg:px-8',
    large: 'max-w-screen-2xl mx-auto px-0 md:px-6 lg:px-8',
    full: 'w-full px-0 md:px-6 lg:px-8',
  };

  return (
    <Component
      className={cn(sizeClasses[size], className)}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Container;
